"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.situacaoMatriculaExt = exports.matriculaAtiva = void 0;
const enums_1 = require("../enums");
const matriculaAtiva = (situacao) => {
    return [
        enums_1.ESituacaoMatricula.Estudando,
        enums_1.ESituacaoMatricula.Aprovado,
        enums_1.ESituacaoMatricula.Reprovado,
        enums_1.ESituacaoMatricula.ExameRecuperação,
    ].includes(situacao);
};
exports.matriculaAtiva = matriculaAtiva;
const situacaoMatriculaExt = (situacao) => {
    switch (situacao) {
        case enums_1.ESituacaoMatricula.Aprovado:
            return 'Aprovado';
        case enums_1.ESituacaoMatricula.Cancelado:
            return 'Cancelado';
        case enums_1.ESituacaoMatricula.Desistente:
            return 'Desistente';
        case enums_1.ESituacaoMatricula.Estudando:
            return 'Estudando';
        case enums_1.ESituacaoMatricula.ExameRecuperação:
            return 'Em Exame / Recuperação';
        case enums_1.ESituacaoMatricula.Falecido:
            return 'Falecido';
        case enums_1.ESituacaoMatricula.Remanejado:
            return 'Remanejado';
        case enums_1.ESituacaoMatricula.Reprovado:
            return 'Reprovado';
        case enums_1.ESituacaoMatricula.Trancado:
            return 'Trancado';
        case enums_1.ESituacaoMatricula.TranferidoCurso:
            return 'Transferido de curso';
        case enums_1.ESituacaoMatricula.Transferido:
            return 'Transferido';
        default:
            return '';
    }
};
exports.situacaoMatriculaExt = situacaoMatriculaExt;
